import { createStore, combineReducers, applyMiddleware, compose } from "redux";
import logger from "redux-logger";
import { createEpicMiddleware } from "redux-observable";
import { discussionBoardAnalytics } from "../helpers/analytics";

export const configureStore = (reducer, rootEpic) => {
  const composeEnhancers =
    (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

  const epicMiddleware = createEpicMiddleware(rootEpic);

  return createStore(
    reducer,
    composeEnhancers(applyMiddleware(epicMiddleware, logger, discussionBoardAnalytics))
  );
};



// WEBPACK FOOTER //
// ./src/store/configureStore.dev.ts